import React from 'react';
import { CloseButton, TextV2, ButtonV2 } from '@withjoy/joykit';
import { Spacer, Wrapper, ContentContainer, Information, CTAButtonContainer, CloseButtonContainer } from './BookingBanner.styles';
import { useTranslation } from '@shared/core';
import { useDashboardTelemetry } from '../../../Dashboard.telemetry';
import { Link } from '@react-router';
import { usePlanningRoutes } from '@apps/admin/routes/Planning/hooks/usePlanningRoutes';

export interface BookingBannerProps {
  handleDismissBannerClick: (e: React.MouseEvent) => void;
  handleBookingBannerOpen: () => void;
  isBannerVisible: boolean;
}

export const BookingBanner: React.FC<BookingBannerProps> = ({ handleDismissBannerClick, isBannerVisible, handleBookingBannerOpen }) => {
  const { bookingBannerCTAClicked } = useDashboardTelemetry();
  const { t2 } = useTranslation('hotelBlock');
  const { bannerText, buttonCTA } = t2('bookingBanner');
  const { hotelBlockPath } = usePlanningRoutes();

  const handleCTAClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    bookingBannerCTAClicked();
  };

  return (
    <Wrapper as={Link} to={hotelBlockPath} onClick={handleCTAClick} isBannerVisible={isBannerVisible}>
      <Spacer />
      <ContentContainer>
        <Information>
          <TextV2 typographyVariant="hed2">{bannerText}</TextV2>
        </Information>
        <CTAButtonContainer>
          <ButtonV2
            as={Link}
            to={hotelBlockPath}
            onClick={handleCTAClick}
            color={'white'}
            borderColor={'white'}
            border="2px solid transparent"
            background={'transparent'}
            borderRadius="20px"
            fontSize="16px"
            fontWeight="semibold"
            _hover={{ border: '2px solid white', background: '#502080', color: 'white' }}
            _active={{
              border: '2px solid white',
              background: '#502080',
              borderColor: 'white',
              color: 'white'
            }}
            variant={'outline'}
            size={'md'}
          >
            {buttonCTA}
          </ButtonV2>
        </CTAButtonContainer>
      </ContentContainer>
      <CloseButtonContainer>
        <CloseButton
          height={7}
          minWidth={7}
          paddingRight={0}
          paddingLeft={0}
          borderRadius={'100%'}
          color={'white'}
          _hover={{ background: '#502080', color: 'white' }}
          _active={{ background: '#502080', color: 'white' }}
          onClick={(e: React.MouseEvent) => handleDismissBannerClick(e)}
        />
      </CloseButtonContainer>
    </Wrapper>
  );
};
